import type { ThemeState } from '@atlaskit/tokens';
import { setGlobalTheme } from '@atlaskit/tokens';

export const applyTheme = async (theme: Partial<ThemeState>): Promise<void> => {
	await setGlobalTheme(theme);
};
